import { DeviceTelemetry } from '../../device-api/device-telemetry';
import { startRenderTimeMonitoring } from '../../utils/perf';
const memoryInterval = 1000;
export class BrowserTelemetry extends DeviceTelemetry {
    context;
    isMemoryMonitoringSupported;
    scheduleUserAgentMemoryTimeout;
    isUserAgentSpecificMemorySupported;
    constructor(context) {
        super();
        this.context = context;
        this.supportedTags.add("FPS" /* PerfTag.fps */);
        this.isMemoryMonitoringSupported = 'memory' in context.performance;
        if (this.isMemoryMonitoringSupported) {
            this.supportedTags.add("MEMORY" /* PerfTag.memory */);
            this.supportedTags.add("MEMORY_LIMIT" /* PerfTag.memoryLimit */);
            this.performMemoryMeasurement = this.performMemoryMeasurement.bind(this);
        }
        this.isUserAgentSpecificMemorySupported =
            this.context.crossOriginIsolated && typeof this.context.performance.measureUserAgentSpecificMemory === 'function';
        if (this.isUserAgentSpecificMemorySupported) {
            this.measureUserAgentMemory = this.measureUserAgentMemory.bind(this);
            this.supportedTags.add("USER_AGENT_SPECIFIC_MEMORY" /* PerfTag.userAgentSpecificMemory */);
        }
    }
    nativeStartMonitoring() {
        const stopRenderTimeMonitoring = startRenderTimeMonitoring(this.telemetryLog);
        const stopUsedMemoryMonitoring = this.startUsedMemoryMonitoring();
        return () => {
            stopRenderTimeMonitoring();
            stopUsedMemoryMonitoring();
        };
    }
    startUsedMemoryMonitoring() {
        let scheduleMemoryInterval;
        if (this.isMemoryMonitoringSupported) {
            scheduleMemoryInterval = setInterval(this.performMemoryMeasurement, memoryInterval);
        }
        if (this.isUserAgentSpecificMemorySupported) {
            this.performUserAgentMemoryMeasurement();
        }
        return () => {
            clearInterval(scheduleMemoryInterval);
            clearTimeout(this.scheduleUserAgentMemoryTimeout);
            this.scheduleUserAgentMemoryTimeout = undefined;
        };
    }
    performMemoryMeasurement() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { usedJSHeapSize, jsHeapSizeLimit } = this.context.performance.memory;
        this.telemetryLog.measure("TELEMETRY" /* PerfKey.telemetry */, "MEMORY" /* PerfTag.memory */, usedJSHeapSize);
        this.telemetryLog.measure("TELEMETRY" /* PerfKey.telemetry */, "MEMORY_LIMIT" /* PerfTag.memoryLimit */, jsHeapSizeLimit);
    }
    performUserAgentMemoryMeasurement() {
        this.scheduleUserAgentMemoryTimeout = setTimeout(this.measureUserAgentMemory, memoryInterval);
    }
    async measureUserAgentMemory() {
        const memory = await this.context.performance.measureUserAgentSpecificMemory();
        this.telemetryLog.measure("TELEMETRY" /* PerfKey.telemetry */, "USER_AGENT_SPECIFIC_MEMORY" /* PerfTag.userAgentSpecificMemory */, memory.bytes);
        if (this.scheduleUserAgentMemoryTimeout) {
            this.performUserAgentMemoryMeasurement();
        }
    }
}
//# sourceMappingURL=browser-telemetry.js.map